<template>
  <section class="swap-discount">
    <social-header v-if="currentEnv" title="置换优惠"></social-header>

    <!-- 优惠图片区域 -->
    <div class="discount-banner">
      <img v-if="topImg" :src="topImg" alt="" />
    </div>

    <div
      class="content-container"
      :style="{ marginTop: topImg ? '0' : '10px' }"
    >
      <!-- 购车置换优惠 -->
      <div class="discount-content">
        <h2 class="section-title">购车置换优惠</h2>
        <div class="discount-card" v-if="equityImg">
          <img :src="equityImg" alt="" />
        </div>
      </div>

      <!-- 表单区域 -->
      <div class="form-content">
        <!-- 品牌车系 -->
        <div class="form-item car-select-item" v-if="isShowCar">
          <span class="form-label">意向车型</span>
          <div class="form-right car-select-right" @click="selectCarHandle">
            <div
              class="car-info"
              v-if="
                formData.brandName || formData.seriesName || formData.modelName
              "
            >
              <div class="car-text">
                <div class="car-brand-series">
                  {{ formData.brandName }} {{ formData.seriesName }}
                </div>
                <div class="car-model">{{ formData.modelName }}</div>
              </div>
            </div>
            <input
              v-else
              type="text"
              :value="carDisplayText"
              class="form-input"
              placeholder="请选择品牌车系"
              readonly
            />
            <span class="car-arrow">›</span>
          </div>
        </div>
        <!-- 手机号 -->
        <div class="form-item">
          <span class="form-label">手机号</span>
          <div class="form-right">
            <input
              type="text"
              v-model="formData.phone"
              class="form-input"
              placeholder="请输入"
              maxlength="11"
            />
            <span
              v-if="isLoggedIn && maskedPhone && formData.phone.includes('*')"
              class="phone-mask"
              >已加密处理</span
            >
            <span class="clear-btn" @click="formData.phone = ''">×</span>
          </div>
        </div>
        <!-- 验证码 -->
        <div class="form-item" v-if="showCaptcha">
          <span class="form-label">验证码</span>
          <div class="form-right captcha-wrap">
            <input
              type="text"
              v-model="formData.captcha"
              class="form-input"
              placeholder="请输入验证码"
              maxlength="6"
            />
            <button
              class="captcha-btn"
              :class="{ disabled: !canGetCaptcha }"
              @click="getCaptcha"
              :disabled="!canGetCaptcha"
            >
              {{ captchaText }}
            </button>
          </div>
        </div>
        <!-- 购车人 -->
        <div class="form-item">
          <span class="form-label">购车人</span>
          <div class="form-right">
            <input
              type="text"
              v-model="formData.buyerName"
              class="form-input"
              placeholder="请输入"
              maxlength="10"
            />
            <span class="clear-btn" @click="formData.buyerName = ''">×</span>
          </div>
        </div>
        <!-- 提交按钮 -->
        <div class="submit-btn" @click="submitForm">获取购车置换优惠</div>
        <!-- 协议勾选 -->
        <div class="agree-item">
          <label class="agree-label">
            <van-checkbox
              v-model="formData.agreed"
              checked-color="#fd641c"
              icon-size="12px"
            ></van-checkbox>
            <span class="agree-text">已阅读并同意</span>
            <a href="#" class="agree-link">《汽车之家隐私政策》</a>
          </label>
        </div>
      </div>
    </div>
    <!-- 底部banner -->
    <div
      v-if="bannerImg && !isShowCar"
      class="bottom-banner"
      @click="getJumpUrl(2)"
    >
      <img :src="bannerImg" alt="" />
    </div>

    <!-- 协议弹窗 -->
    <div
      class="modal-mask"
      v-if="showAgreeModal"
      @click="showAgreeModal = false"
    >
      <div class="modal-content" @click.stop>
        <div class="modal-header">提示</div>
        <div class="modal-body">请先阅读并同意《汽车之家隐私政策》</div>
        <div class="modal-footer">
          <button class="modal-btn" @click="showAgreeModal = false">
            我知道了
          </button>
        </div>
      </div>
    </div>

    <!-- 图形验证码弹窗 -->
    <div
      class="modal-mask"
      v-if="showImageCaptchaModal"
      @click="showImageCaptchaModal = false"
    >
      <div class="modal-content image-captcha-modal" @click.stop>
        <div class="modal-header">图片验证</div>
        <div class="modal-body">
          <div class="image-captcha-container">
            <img
              v-if="imageCaptcha"
              :src="imageCaptcha"
              alt="验证码"
              class="image-captcha-img"
            />
            <span class="refresh-captcha" @click.stop="refreshImageCaptcha"
              >换一张</span
            >
          </div>
          <input
            type="text"
            v-model="imageCaptchaInput"
            class="image-captcha-input"
            placeholder="请输入图形验证码"
            maxlength="6"
          />
        </div>
        <div class="modal-footer image-captcha-footer">
          <button
            class="modal-btn cancel-btn"
            @click="showImageCaptchaModal = false"
          >
            取消
          </button>
          <button class="modal-btn confirm-btn" @click="confirmImageCaptcha">
            确定
          </button>
        </div>
      </div>
    </div>

    <!-- 品牌车系车型选择器 -->
    <car-selector
      ref="carSelector"
      :platformParams="platformParams"
      @confirm="onCarConfirm"
    ></car-selector>

    <!-- 单按钮弹窗 -->
    <simple-dialog
      v-model="showSimpleDialog"
      :content="simpleDialogContent"
      :confirm-text="simpleDialogConfirmText"
    ></simple-dialog>
  </section>
</template>

<script>
import Tools from "../../tools/tools.js";
import { mapGetters } from "vuex";
import SocialHeader from "../../components/social-header.vue";
import CarSelector from "../../components/car-selector.vue";
import SimpleDialog from "../../components/simple-dialog.vue";
import Dialog from "../../plugins/dialog.js";
import { Toast } from "vant";
import {
  getIsNeedCodeReq,
  getCaptchaReq,
  getImageCaptchaReq,
  recycleCaptchaReq,
  getJumpUrlReq,
  getResourceReq,
  getCarSeriesInfoReq,
} from "../../api/swap.js";
import {
  isWeiXin,
  isDingDing,
  changeDocumentTitle,
} from "../../service/environment";

export default {
  components: {
    SocialHeader,
    CarSelector,
    SimpleDialog,
  },
  name: "SwapDiscount",
  data: function () {
    return {
      formData: {
        buyerName: "",
        phone: "",
        captcha: "",
        agreed: false,
        brandId: "",
        brandName: "",
        seriesId: "",
        seriesName: "",
        modelId: "",
        modelName: "",
      },
      isLoggedIn: false,
      maskedPhone: "",
      realPhone: "",
      showCaptcha: false,
      captchaText: "获取验证码",
      captchaCountdown: 0,
      showAgreeModal: false,
      showImageCaptchaModal: false,
      imageCaptcha: "",
      imageCaptchaInput: "",
      pvareaid: Tools.getQueryString("pvareaid") || "",
      platformParams: Tools.getQueryString("platformParams") || "",
      activityId: Tools.getQueryString("activityId") || "",
      agentNo: Tools.getQueryString("agentNo") || "",
      topImg: "",
      bannerImg: "",
      equityImg: "",
      isShowCar: false,
      lastSubmitTime: 0,
      showSimpleDialog: false,
      simpleDialogContent: "",
      simpleDialogConfirmText: "确认",
      captchaTimer: null,
      pvObj: {}, // 留资线索页PV参数
      obj: {}, // 留资线索页最终页参数
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo",
    }),
    currentEnv() {
      if (isWeiXin()) {
        return false;
      } else if (isDingDing()) {
        return false;
      } else {
        return true;
      }
    },
    currentPhone() {
      const isMasked = this.formData.phone.includes("****");
      return this.isLoggedIn && this.realPhone && isMasked
        ? this.realPhone
        : this.formData.phone;
    },
    canGetCaptcha() {
      const phonePattern = /^1[3-9]\d{9}$/;
      return (
        phonePattern.test(this.currentPhone) && this.captchaCountdown === 0
      );
    },
    carDisplayText() {
      const { brandName, seriesName, modelName } = this.formData;
      if (brandName && seriesName && modelName) {
        return `${brandName} ${seriesName} ${modelName}`;
      }
      if (brandName && seriesName) {
        return `${brandName} ${seriesName}`;
      }
      if (brandName) {
        return brandName;
      }
      return "";
    },
  },
  watch: {
    userInfo: function (val) {
      if (val && val.agentPhone) {
        this.isLoggedIn = true;
        this.realPhone = val.agentPhone;
        this.formData.phone = this.maskPhone(val.agentPhone);
        this.maskedPhone = this.formData.phone;
        this.showCaptcha = false;
      }
    },
    "formData.phone": function (newVal) {
      if (newVal && newVal.length === 11) {
        this.checkCaptchaRequired(newVal);
      } else if (!newVal) {
        this.showCaptcha = false;
      }
    },
  },
  created: function () {
    changeDocumentTitle("置换优惠");
    this.initPage();
    this.pvObj = {
      site: window.pageCode.site,
      category: window.pageCode.category,
      subcategory: window.pageCode.subcategory,
    };
    this.obj = {
      pvareaid: this.pvareaid,
      agentNo: this.agentNo,
      activityId: this.activityId,
    };
  },
  beforeDestroy() {
    if (this.captchaTimer) {
      clearInterval(this.captchaTimer);
      this.captchaTimer = null;
    }
  },
  methods: {
    initPage() {
      if (this.userInfo && this.userInfo.agentPhone) {
        this.isLoggedIn = true;
        this.realPhone = this.userInfo.agentPhone;
        this.formData.phone = this.maskPhone(this.userInfo.agentPhone);
        this.maskedPhone = this.formData.phone;
        this.showCaptcha = false;
      }
    },

    selectCarHandle() {
      this.$refs.carSelector.open();
    },

    onCarConfirm(carInfo) {
      this.formData.brandId = carInfo.brandId;
      this.formData.brandName = carInfo.brandName;
      this.formData.seriesId = carInfo.seriesId;
      this.formData.seriesName = carInfo.seriesName;
      this.formData.modelId = carInfo.modelId;
      this.formData.modelName = carInfo.modelName;
    },

    // 隐藏手机号中间四位
    maskPhone(phone) {
      if (phone && phone.length === 11) {
        return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      }
      return phone;
    },

    // 检查是否需要验证码
    checkCaptchaRequired(phone) {
      const phonePattern = /^1[3-9]\d{9}$/;
      if (!phonePattern.test(phone)) {
        return;
      }
      if (this.isLoggedIn && this.realPhone) {
        const isMasked = phone.includes("****");
        if (isMasked || phone === this.realPhone) {
          this.showCaptcha = false;
        } else {
          this.checkIsNeedCode();
        }
      } else {
        this.checkIsNeedCode();
      }
    },

    // 检查是否需要验证码
    async checkIsNeedCode() {
      try {
        const { data } = await getIsNeedCodeReq({
          mobile: this.currentPhone,
          pvAreaId: 0,
        });
        if (data.result.data == 1) {
          this.showCaptcha = true;
        } else {
          this.showCaptcha = false;
        }
      } catch (error) {
        Dialog.toast({ title: "检查是否需要验证码失败" });
      }
    },

    // 获取验证码
    async getCaptcha(gvCode = "") {
      if (!this.canGetCaptcha) return;
      try {
        const { data } = await getCaptchaReq({
          mobile: this.currentPhone,
          gvCode,
        });
        if (data.result.code == 0) {
          Toast("验证码发送成功");
          this.captchaCountdown = 60;
          this.captchaText = "60s";
          this.showImageCaptchaModal = false;
          this.imageCaptchaInput = "";
          this.captchaTimer = setInterval(() => {
            this.captchaCountdown--;
            if (this.captchaCountdown > 0) {
              this.captchaText = `${this.captchaCountdown}s`;
            } else {
              clearInterval(this.captchaTimer);
              this.captchaTimer = null;
              this.captchaText = "获取验证码";
            }
          }, 1000);
        } else if (data.returncode == 3000100) {
          await this.refreshImageCaptcha();
          this.showImageCaptchaModal = true;
        } else {
          Toast(data.message);
        }
      } catch (error) {
        Toast("验证码发送失败");
      }
    },

    // 获取图形验证码
    async refreshImageCaptcha() {
      this.imageCaptcha = "";
      try {
        const { data } = await getImageCaptchaReq({
          mobile: this.currentPhone,
        });
        this.imageCaptcha = `data:image/png;base64,${data.result}`;
      } catch (error) {
        Toast("获取图形验证码失败");
      }
    },

    // 确认图形验证码
    confirmImageCaptcha() {
      if (!this.imageCaptchaInput.trim()) {
        Toast("请输入图形验证码");
        return;
      }
      this.getCaptcha(this.imageCaptchaInput.trim());
    },

    // 回收验证码
    async recycleCaptcha() {
      try {
        const res = await recycleCaptchaReq({
          mobile: this.currentPhone,
          verifyCode: this.formData.captcha,
        });
        if (res.data.returncode == 0) {
          await this.getJumpUrl(1);
        } else {
          Toast(res.data.message);
        }
      } catch (error) {
        Toast("验证码回收失败");
      }
    },

    // 提交表单
    async submitForm() {
      // 节流处理：2秒内只允许提交一次
      const now = Date.now();
      if (now - this.lastSubmitTime < 2000) {
        return;
      }
      this.lastSubmitTime = now;

      // 页面校验
      if (
        !this.formData.brandId ||
        !this.formData.seriesId ||
        !this.formData.modelId
      ) {
        Toast("请选择品牌车系");
        return;
      }
      if (!this.formData.buyerName) {
        Toast("购车人不可为空");
        return;
      }
      if (!this.currentPhone) {
        Toast("手机号不可为空");
        return;
      }
      const phonePattern = /^1[3-9]\d{9}$/;
      if (!phonePattern.test(this.currentPhone)) {
        Toast("请输入正确的手机号");
        return;
      }
      if (this.showCaptcha && !this.formData.captcha) {
        Toast("验证码不可为空");
        return;
      }
      if (!this.formData.agreed) {
        this.showAgreeModal = true;
        return;
      }
      // 如果需要验证码则回收验证码
      if (this.showCaptcha) {
        await this.recycleCaptcha();
      } else {
        await this.getJumpUrl(1);
      }
    },

    // 调用接口
    async getJumpUrl(type) {
      type == 1
        ? Tools.tongji(
            "cf_gouchexiansuo_tijiao_button_click",
            this.obj,
            2,
            this.pvObj
          )
        : Tools.tongji(
            "cf_gouchexiansuo_banner_click",
            this.obj,
            2,
            this.pvObj
          );

      try {
        const { platformParams, activityId, pvareaid } = this,
          { buyerName, modelId } = this.formData;
        const isMasked = this.formData.phone.includes("****");
        const phoneToCheck =
          this.isLoggedIn && this.realPhone && isMasked
            ? this.realPhone
            : this.formData.phone;
        const { data } = await getJumpUrlReq({
          Type: type,
          PlatformParam: platformParams,
          ActivityId: activityId,
          PhoneNumber: phoneToCheck,
          UserName: buyerName,
          PvAreaId: pvareaid,
          SpecId: modelId,
        });
        if (data.code == 0) {
          if (data.data) {
            window.location.href = data.data;
          } else {
            if (type == 1) {
              console.log("购车信息提交成功");
              this.showSimpleDialog = true;
              this.simpleDialogContent = "购车信息提交成功";
              this.simpleDialogConfirmText = "确定";
            } else if (type == 2) {
              // 获取资源位跳转链接
              console.log("获取资源位跳转链接");
            }
          }
        } else {
          Toast(data.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 获取头图资源位
    async getTopImgResource() {
      try {
        const { data } = await getResourceReq({
          locationId: 703,
        });
        this.topImg = data[0].link;
      } catch (error) {
        console.log(error);
      }
    },

    // 获取权益资源位
    async getDiscountResource() {
      try {
        const { data } = await getResourceReq({
          locationId: 705,
        });
        this.equityImg = data[0].link;
      } catch (error) {
        console.log(error);
      }
    },

    // 获取banner资源位
    async getBannerResource() {
      try {
        const { data } = await getResourceReq({
          locationId: 704,
        });
        this.bannerImg = data[0].link;
        if (this.bannerImg) {
          Tools.tongji("cf_gouchexiansuo_banner_show", this.obj, 1, this.pvObj);
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 是否展示品牌车系表单
    async checkShowBrandSeriesForm() {
      try {
        const { data } = await getCarSeriesInfoReq({
          type: 1,
          MediaId: "",
          PlatformParam: this.platformParams,
        });
        if (data.code == 0) {
          this.isShowCar = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getTopImgResource();
    this.getDiscountResource();
    this.getBannerResource();
    this.checkShowBrandSeriesForm();
    Tools.tongji(
      "cf_gouchexiansuo_tijiao_button_show",
      this.obj,
      1,
      this.pvObj
    );
  },
};
</script>

<style>
.swap-discount {
  width: 100vw;
  height: 100vh;
  background-color: #fef8eb;
}
.discount-banner {
  width: 100%;
  height: 10.1563rem;
}
.discount-banner img {
  width: 100%;
  height: 100%;
}

.content-container {
  width: 95%;
  background-color: #fff;
  border-radius: 0.5rem;
  margin: 0 auto;
  padding: 1.4063rem 0.75rem 0.75rem 0.75rem;
  margin-bottom: 0.8125rem;
  box-sizing: border-box;
  position: relative;
  z-index: 10;
}

.discount-content {
  margin-bottom: 0.5rem;
}
.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #111e36;
  margin-bottom: 0.75rem;
}
.discount-card {
  width: 100%;
  margin: 0 auto;
}

.discount-card img {
  width: 100%;
  height: 100%;
}
.form-item {
  display: flex;
  align-items: center;
  padding: 0.58rem 0;
  border-bottom: 0.0625rem solid #f0f0f0;
}
.form-label {
  font-size: 1rem;
  color: #111e36;
  width: 4.5rem;
  flex-shrink: 0;
}
.form-right {
  font-size: 1rem;
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 品牌车系选择样式 */
.car-select-item {
  align-items: center;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.car-select-right {
  align-items: center;
  justify-content: space-between;
}

.car-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.car-logo {
  width: 5rem;
  height: 3.75rem;
  object-fit: contain;
  margin-right: 0.75rem;
  border-radius: 0.25rem;
  background: #f5f5f5;
}

.car-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.car-brand-series {
  font-size: 1rem;
  font-weight: 500;
  color: #111e36;
  margin-bottom: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.car-model {
  font-size: 0.875rem;
  color: #828ca0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.car-arrow {
  font-size: 1.25rem;
  color: #c5cad4;
  margin-left: 0.5rem;
  flex-shrink: 0;
}
.form-input {
  height: 2rem;
  font-size: 1rem;
  color: #111e36;
  background: transparent;
  border: none;
  outline: none;
}
.form-input::placeholder {
  color: #c5cad4;
}

.clear-btn {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #c5cad4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: #fff;
  cursor: pointer;
  position: relative;
  right: 0.3125rem;
}

.phone-mask {
  width: 4.5rem;
  font-size: 0.75rem;
  color: #828ca0;
  margin-left: -1.5rem;
}

.captcha-wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.captcha-btn {
  width: 5.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: #ff8c42;
  background: transparent;
  border: none;
  flex-shrink: 0;
  position: relative;
  right: 1.5625rem;
}

.captcha-btn.disabled {
  color: #c0c4cc;
}

.agree-item {
  margin-top: 0.625rem;
  border-bottom: none;
}

.agree-label {
  display: flex;
  align-items: center;
  font-size: 0.625rem;
  cursor: pointer;
}

.agree-label input {
  display: none;
}

.agree-text {
  margin-left: 0.2rem;
  color: #828ca0;
}

.agree-link {
  color: #464e64;
  text-decoration: none;
}

.submit-btn {
  width: 20.9375rem;
  height: 3rem;
  background: linear-gradient(90deg, #ff8c3b 0%, #ff6600 100%);
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.4rem;
  text-align: center;
  letter-spacing: 0rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.125rem;
  margin: 0 auto;
  margin-top: 0.75rem;
}

.bottom-banner {
  width: 95%;
  height: 5rem;
  margin-top: 0.75rem;
  border-radius: 0.5rem;
  margin: 0 auto;
}

.bottom-banner img {
  width: 100%;
  height: 100%;
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-content {
  width: 17.5rem;
  background: #fff;
  border-radius: 0.5rem;
  overflow: hidden;
}

.modal-header {
  padding: 1rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  color: #111e36;
  border-bottom: 1px solid #f0f0f0;
}

.modal-body {
  padding: 1.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: #111e36;
}

.modal-footer {
  padding: 1rem;
  border-top: 1px solid #f0f0f0;
}

.modal-btn {
  width: 100%;
  height: 2.5rem;
  background: #ff8c42;
  color: #fff;
  font-size: 0.875rem;
  border: none;
  border-radius: 0.25rem;
}

.image-captcha-modal {
  width: 20rem;
}

.image-captcha-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.image-captcha-img {
  width: 7.5rem;
  height: 2.5rem;
  border-radius: 0.25rem;
}

.refresh-captcha {
  font-size: 0.75rem;
  color: #ff8c42;
  margin-left: 0.5rem;
  cursor: pointer;
}

.image-captcha-input {
  width: 100%;
  height: 2.5rem;
  font-size: 1rem;
  color: #111e36;
  background: #f5f7fa;
  border: 0.0625rem solid #e4e7ed;
  border-radius: 0.25rem;
  padding: 0 0.75rem;
  outline: none;
  box-sizing: border-box;
}

.image-captcha-input::placeholder {
  color: #c5cad4;
}

.image-captcha-footer {
  display: flex;
  gap: 0.5rem;
}

.image-captcha-footer .cancel-btn {
  background: #f5f7fa;
  color: #606266;
}

.image-captcha-footer .confirm-btn {
  background: #ff8c42;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/swapDiscount.vue